
import request from '@/utils/request'

// tbox版本数据
export function GetTboxVersiondata(data) {
  return request({
    url: '/data/version/queryVersionList',
    method: 'post',
    data
  })
}
// 新增
export function addTboxVersion(data) {
    return request({
      url: '/data/version/insertVersion',
      method: 'post',
      data
    })
}

